<mat-sidenav-container class="sidenav-container">
	<mat-sidenav-content class="sidenav-content">
		<div class="content-wrapper" id="portoBankMainScroll">
			<router-outlet></router-outlet>
		</div>

		<div class="bottom-banner" *ngIf="!(client$ | async)?.id" (click)="redirectClick()">
			{{
				isMobile
					? 'Peça seu Cartão Porto Bank'
					: 'Peça seu Cartão Porto Bank para ter acesso a experiências inesquecíveis'
			}}
		</div>
	</mat-sidenav-content>

	<mat-sidenav #sidenav [mode]="sidenavMode" class="sidenav" (openedChange)="onOpenedChange($event)">
		@if (client$ | async; as client) {
			<div class="menu-header">
				<h1>{{ client.fullName }}</h1>
			</div>
		} @else {
			<div
				class="menu-header"
				style="justify-content: flex-start; gap: 20px; align-items: center"
				[routerLink]="['/entrar']"
				[queryParams]="{ login: true }"
			>
				<h1>Login</h1>
				<mat-icon
					svgIcon="porto-bank-icons:right-arrow"
					style="width: 15px; height: 15px; --icon-color: var(--content-primary)"
				></mat-icon>
			</div>
		}
		@if (client$ | async; as client) {
			<div class="menu-section">
				<h3>Minha conta</h3>
				<mat-nav-list>
					<a mat-list-item routerLink="perfil">
						<div class="center-text">
							<mat-icon svgIcon="porto-bank-icons:profile-circle"></mat-icon>
							<span>Meus dados</span>
							<mat-icon
								svgIcon="porto-bank-icons:right-arrow"
								style="width: 15px; height: 15px"
							></mat-icon>
						</div>
					</a>

					<a mat-list-item routerLink="reservas-e-checkins">
						<div class="center-text">
							<mat-icon svgIcon="porto-bank-icons:calendar"></mat-icon>
							<span>Histórico</span>
							<mat-icon
								svgIcon="porto-bank-icons:right-arrow"
								style="width: 15px; height: 15px"
							></mat-icon>
						</div>
					</a>
					<a mat-list-item (click)="logout()">
						<div class="center-text">
							<mat-icon svgIcon="porto-bank-icons:logout"></mat-icon>
							<span>Sair</span>
						</div>
					</a>
				</mat-nav-list>
			</div>

			<div style="height: 2px; width: 100%; background-color: #f6f6f6"></div>
		}

		<!-- Common options -->
		<div class="menu-section">
			<mat-nav-list>
				<a mat-list-item routerLink="como-funciona">
					<div class="center-text">
						<mat-icon svgIcon="porto-bank-icons:info"></mat-icon>
						<span>Como funciona</span>
						<mat-icon
							svgIcon="porto-bank-icons:right-arrow"
							style="width: 15px; height: 15px"
						></mat-icon>
					</div>
				</a>
				<a mat-list-item routerLink="/faq">
					<div class="center-text">
						<mat-icon svgIcon="porto-bank-icons:question"></mat-icon>
						<span>FAQ</span>
						<mat-icon
							svgIcon="porto-bank-icons:right-arrow"
							style="width: 15px; height: 15px"
						></mat-icon>
					</div>
				</a>
				<a mat-list-item routerLink="politica-de-privacidade">
					<div class="center-text">
						<mat-icon svgIcon="porto-bank-icons:lock"></mat-icon>
						<span>Política de privacidade</span>
						<mat-icon
							svgIcon="porto-bank-icons:right-arrow"
							style="width: 15px; height: 15px"
						></mat-icon>
					</div>
				</a>
				<a mat-list-item routerLink="termos-de-uso">
					<div class="center-text">
						<mat-icon svgIcon="porto-bank-icons:file-text"></mat-icon>
						<span>Termos de uso</span>
						<mat-icon
							svgIcon="porto-bank-icons:right-arrow"
							style="width: 15px; height: 15px"
						></mat-icon>
					</div>
				</a>
				<!-- <a mat-list-item routerLink="sobre-a-tagme">
					<div class="center-text">
						<mat-icon svgIcon="porto-bank-icons:settings"></mat-icon>
						<span>Sobre a Tagme</span>
						<mat-icon
							svgIcon="porto-bank-icons:right-arrow"
							style="width: 15px; height: 15px"
						></mat-icon>
					</div>
				</a> -->
			</mat-nav-list>
		</div>
	</mat-sidenav>
</mat-sidenav-container>
